import { ClientDashboardHomeNotificationDto } from '@hoqus/connectis-client-dashboard-types';
import { DashboardNotificationEnum } from 'types/DashboardNotificationEnum/DashboardNotificationEnum.ts';
import { DashboardNotificationType } from './DashboardNotificationType.ts';

export const mapDtoToDashboardNotificationType = (
  dto: ClientDashboardHomeNotificationDto,
): DashboardNotificationType => ({
  id: dto.id,
  type: dto.type as DashboardNotificationEnum,
  displayDate: dto.displayDate,
  jobOrderId: dto.jobOrderId,
  blindId: dto.blindId,
  jobOrderLabel: dto.jobOrderLabel,
  blindLabel: dto.blindLabel,
  meetingDate: dto.meetingDate,
});
